export default {
  room: "👈 Room",
  roomList: "📚 Rooms",
  reload: "🌀 Reload",
  logout: "🚪 Logout",
  back: "👈 Back",
  createNewRoom: "✏️ Create",
};
